import { Component, OnInit, Input, Output, EventEmitter,
ChangeDetectionStrategy } from '@angular/core';

import { staggerIn, popIn } from '@app/animations';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-products-lists-food',
  templateUrl: './products-lists-food.component.html',
  styleUrls: ['./products-lists-food.component.css'],
  animations: [staggerIn, popIn],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsListsFoodComponent implements OnInit {
  @Input()
  products;

  @Input()
  selectedProducts;

  @Input()
  drillDown;

  @Input()
  drillDownFood;

  @Input()
  role;

  @Input()
  followType;

  @Input()
  countryDepartments;

  @Output()
  selected = new EventEmitter();

  checkboxes = {};
  countryDepartmentsRed;
  openL3s = {};
  openParents = {};
  openDeps = {};
  openCodes = {};
  openGrandParent = {};

  constructor() { }

  get isCountryBuyer() {
    return this.role && this.role && rolesUtils.isCountryUser(this.role);
  }

  ngOnInit() {
  }

  toggleSelected({ id, metaKey, shiftKey }) {
    if (metaKey && !shiftKey) {
      if (this.isSelected(id)) {
        this.selected.emit(
          this.selectedProducts.map(p => p.id).filter(i => i !== id)
        );
      } else {
        this.selected.emit([...this.selectedProducts.map(p => p.id), id]);
      }
    } else if (!metaKey && shiftKey) {
      if (this.selectedProducts && this.selectedProducts.length) {
        let mapped = [];
        if (!this.isCountryBuyer) {
          const l3s = Object.keys(this.drillDown);
          for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
            const l3 = this.drillDown[l3s[i]];
            const l4s = Object.keys(l3);
            for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
              const l4 = l3[l4s[j]];
              const mainCodes = Object.keys(l4);
                for (
                  let l = 0, mainCodesLength = mainCodes.length;
                  l < mainCodesLength;
                  l++
                ) {
                  const mainCode = l4[mainCodes[l]];
                  mapped = [...mapped, ...mainCode.map(product => product.id)];
                }
            }
          }
        } else {
          const mainCodes = Object.keys(this.drillDown);
          for (
            let l = 0, mainCodesLength = mainCodes.length;
            l < mainCodesLength;
            l++
          ) {
            const mainCode = this.drillDown[mainCodes[l]];
            mapped = [...mapped, ...mainCode.map(product => product.id)];
          }
        }

        const start = mapped.indexOf(this.selectedProducts[0].id);
        const end = mapped.indexOf(id);

        let tempSelection;
        if (start > end) {
          tempSelection = [...mapped].slice(end, start + 1).reverse();
        } else {
          tempSelection = mapped.slice(start, end + 1);
        }
        this.selected.emit(tempSelection);
      }
    } else {
      if (
        (this.isSelected(id) && this.selectedProducts.length > 1) ||
        !this.isSelected(id)
      ) {
        this.selected.emit([id]);
      } else {
        this.selected.emit([]);
      }
    }
  }

  isSelected(id) {
    return this.selectedProducts.map(p => p.id).includes(id);
  }

  trackByFn(index, item) {
    return item.code;
  }

  trackMainCodeFn(index, item) {
    return item.key;
  }

  trackDepartmentFn(index, item) {
    return item.key;
  }

  selectAll(checked) {
    if (checked) {
      const mapped = this.products.map(p => p.id);
      this.selected.emit(mapped);
    } else {
      this.selected.emit([]);
    }
  }

  checkIndetermined(key) {
    let mapped = [];
    const [l3Key, l4Key, mainCodeKey] = key;
    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const mainCodes = Object.keys(l4).filter(mainCode =>
          mainCodeKey ? mainCode === mainCodeKey : true
        );
        for (
          let l = 0, mainCodesLength = mainCodes.length;
          l < mainCodesLength;
          l++
        ) {
          const mainCode = l4[mainCodes[l]];
          mapped = [...mapped, ...mainCode.map(product => product.id)];
        }
      }
    }
    const ids = this.selectedProducts.map(p => p.id);
    return (
      !mapped.every(id => ids.includes(id)) &&
      mapped.some(id => ids.includes(id))
    );
  }

  checkChecked(key) {
    let mapped = [];
    const [l3Key, l4Key, mainCodeKey] = key;

    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const mainCodes = Object.keys(l4).filter(mainCode =>
          mainCodeKey ? mainCode === mainCodeKey : true
        );
        for (
          let l = 0, mainCodesLength = mainCodes.length;
          l < mainCodesLength;
          l++
        ) {
          const mainCode = l4[mainCodes[l]];
          mapped = [...mapped, ...mainCode.map(product => product.id)];
        }
      }
    }
    const ids = this.selectedProducts.map(p => p.id);
    return mapped.every(id => ids.includes(id));
  }

  treeSelection(key, event) {
    const state = event.target.checked;
    let mapped = [];
    const [l3Key, l4Key, mainCodeKey] = key;
    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const mainCodes = Object.keys(l4).filter(mainCode =>
          mainCodeKey ? mainCode === mainCodeKey : true
        );
        for (
          let l = 0, mainCodesLength = mainCodes.length;
          l < mainCodesLength;
          l++
        ) {
          const mainCode = l4[mainCodes[l]];
          mapped = [...mapped, ...mainCode.map(product => product.id)];
        }
      }
    }

    const ids = this.selectedProducts.map(p => p.id);
    if (state) {
      this.selected.emit([...ids, ...mapped.filter(id => !ids.includes(id))]);
    } else {
      this.selected.emit(ids.filter(id => !mapped.includes(id)));
    }
  }

  nameDepartment(id) {
    // console.log('list', this.countryDepartments);
    this.countryDepartmentsRed = this.countryDepartments.reduce((acc, cp) => {
      acc[cp.id] = cp.name;

      return acc;
    }, {});

    return this.countryDepartmentsRed[id];
  }

}
